module.exports = __webpack_public_path__ + "media/images/icons/flags/CF-f85598087dbab378973cd01690ef5cbf.svg";